import React from 'react';

// Define button styles
const BUTTON_STYLES = {
    nothing: 'text-sm text-primary font-semibold px-6 py-1',
    border: 'text-sm text-primary bg-white border-primary border-2 font-semibold px-6 py-1 rounded-md',
    background: 'text-sm text-white bg-primary font-semibold border-2 border-primary px-6 py-1 rounded-md',
    fullWidth: 'text-sm text-white bg-primary font-semibold border-2 border-primary px-6 py-1 rounded-md w-full',
};

const buttonStyleMap: Record<number, string> = {
    1: BUTTON_STYLES.border,
    2: BUTTON_STYLES.background,
    3: BUTTON_STYLES.fullWidth,
    4: BUTTON_STYLES.nothing,
};

interface ConfirmationPopupProps {
    header?: string;
    message: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    confirmLabel?: string;
    cancelLabel?: string;
    imageSrc?: string;
    confirmBtnStyle?: 1 | 2 | 3 | 4;
    cancelBtnStyle?: 1 | 2 | 3 | 4;
    withRemovePopupBtn?: () => void;
    popupSize?: 1 | 2 | 3;
}


const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
    header,
    message,
    onConfirm,
    onCancel,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    imageSrc,
    confirmBtnStyle = 1,
    cancelBtnStyle = 1,
    popupSize = 1,
    withRemovePopupBtn,
  }) => {
    const confirmButtonStyle = buttonStyleMap[confirmBtnStyle];
    const cancelButtonStyle = buttonStyleMap[cancelBtnStyle];
    const popupWidth = {
      1: "w-11/12 sm:w-3/4 md:w-1/2 lg:w-1/3",
      2: "w-10/12 sm:w-2/3 md:w-1/2 lg:w-5/12",
    }[popupSize] || "w-11/12";
  
    return (
      <div className="fixed inset-0 flex justify-center items-center bg-gray-600 bg-opacity-20 z-50">
        <div
          className={`relative ${popupWidth} p-6 bg-white rounded-lg shadow-lg text-center`}
        >
          {/* Close Button */}
          {withRemovePopupBtn && (
            <button
              onClick={withRemovePopupBtn}
              className="absolute top-4 right-4 flex items-center justify-center w-8 h-8 rounded-full bg-[#4C4C4C] hover:bg-[#6A6A6A] transition duration-200"
              aria-label="Close"
            >
              <span className="text-white text-sm">X</span>
            </button>
          )}
  
          {/* Image */}
          {imageSrc && (
            <img
              src={imageSrc}
              alt="Popup Visual"
              className="w-32 sm:w-48 mx-auto mb-4"
            />
          )}
  
          {/* Header */}
          {header && (
            <p className="text-lg font-bold text-gray-800">{header}</p>
          )}
  
          {/* Message */}
          <p
            className={`mt-2 ${
              header ? "text-gray-600" : "text-gray-800"
            } text-base leading-relaxed`}
          >
            {message}
          </p>
  
          {/* Buttons */}
          <div className="flex justify-center space-x-4 mt-4">
            {onCancel && (
              <button
                onClick={onCancel}
                className={`${cancelButtonStyle} px-6 py-2 rounded-md transition duration-200`}
              >
                {cancelLabel}
              </button>
            )}
            {onConfirm && (
              <button
                onClick={onConfirm}
                className={`${confirmButtonStyle} px-6 py-2 rounded-md transition duration-200`}
              >
                {confirmLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };
  

export default ConfirmationPopup;
